/*  ========================================================================
    # Scripts - CTA Interaction
    ========================================================================  */

const CtaInteraction = {
  cfg: {
    ctaInteractionToggle: document.querySelectorAll('[data-cta-interaction-trigger]'),
    states: {
      interactiveActive: 's-cta__interactive--active'
    }
  },

  /**
   * Handle cta interaction toggle
   */
  handleCtaInteractionToggle() {
    this.cfg.ctaInteractionToggle.forEach(element => {
      element.addEventListener('click', () => {
        element.parentElement.classList.toggle(this.cfg.states.interactiveActive);
      });
    });
  },

  /**
   * Initialize.
   */
  init() {
    if (this.cfg.ctaInteractionToggle) {
      this.handleCtaInteractionToggle();
    }
  }
};

export default CtaInteraction;
